import { WORKFLOW_CAMPAIGN_DATA_SCIENCE_OPTIMIZATIONS } from '../../../constants';
import { WorkflowNodeCampaign } from '../../../types';

export const workflowCampaignUsesSendTimeOptimization = (campaign: WorkflowNodeCampaign) =>
  campaign.dataScienceOptimizations.includes(
    WORKFLOW_CAMPAIGN_DATA_SCIENCE_OPTIMIZATIONS.SEND_TIME_OPTIMIZATION,
  );

export const workflowCampaignUsesFrequencyOptimization = (campaign: WorkflowNodeCampaign) =>
  campaign.dataScienceOptimizations.includes(
    WORKFLOW_CAMPAIGN_DATA_SCIENCE_OPTIMIZATIONS.FREQUENCY_OPTIMIZATION,
  );
